import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade, Setting, } from '@app-state';
import { QueueItemPriority, } from '@models';
import { FileDownloadService, MapperService, } from '@services';
import { CSVParser, ICSVParseErrorCode, ICSVParseErrorType, } from '@services/csv-parser.service';
import { SUPPORTED_DATE_FORMATS } from '@services/generics/constants';
import { ODataService } from '@services/generics/odata.service';
import { isEmptyObject } from '@utils/audit.utils';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import { BulkCommitType, CSVFields, ItemPriority, } from './bulk-add-items.types';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../services/csv-parser.service";
import * as i3 from "../../../../services/file.download.service";
import * as i4 from "../../../../app-state/app-state.facade";
var OUTPUT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
var KNOWN_FIELDS = ['Reference', 'Deadline', 'Priority', 'Postpone'];
var BulkAddItemsModalService = /** @class */ (function (_super) {
    tslib_1.__extends(BulkAddItemsModalService, _super);
    function BulkAddItemsModalService(http, _parser, _downloadService, _appState) {
        var _this = _super.call(this, http, MapperService.queueItemDtoMap) || this;
        _this._parser = _parser;
        _this._downloadService = _downloadService;
        _this._appState = _appState;
        _this._endpoint = '/odata/Queues/UiPathODataSvc.BulkAddQueueItems';
        return _this;
    }
    Object.defineProperty(BulkAddItemsModalService.prototype, "supportedDateFormats", {
        get: function () {
            return SUPPORTED_DATE_FORMATS;
        },
        enumerable: true,
        configurable: true
    });
    BulkAddItemsModalService.prototype.parseFile = function (file) {
        var _this = this;
        return this._parser.parseFile(file, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: true,
            maxFileSize: 2 * 1024 * 1024 * 1024,
            maxRows: this._appState.settings.get(Setting.uploadQueuesMaxNumberOfItems) || 0,
        }).pipe(map(function (_a) {
            var data = _a.data, errors = _a.errors, meta = _a.meta;
            return ({
                meta: meta,
                // this._rowMapper mutates the errors argument.
                data: data.map(function (row, i) { return _this._rowMapper(row, i, errors); }),
                // sort and switch to 1-indexed rows.
                errors: errors.map(function (err) { return (tslib_1.__assign({}, err, { row: err.row + 1 })); }).sort(function (err1, err2) { return err1.row - err2.row; }),
            });
        }));
    };
    BulkAddItemsModalService.prototype.downloadFile = function (originalFilename, filenameSuffix, items) {
        var _this = this;
        var filename;
        var mapItems = items.map(function (row) { return _this._reverseMapToCsv(row); });
        var csvString = this._parser.generateFile(mapItems);
        originalFilename = originalFilename.toLowerCase();
        if (originalFilename.slice(-4) === '.csv') {
            filename = originalFilename.slice(0, -4) + " - " + filenameSuffix + ".csv";
        }
        else {
            filename = filenameSuffix + ".csv";
        }
        this._downloadService.downloadStringAsFile(filename, 'text/csv', csvString);
    };
    BulkAddItemsModalService.prototype.bulkAddQueueItems = function (queueItems, queueName, commitType) {
        var _this = this;
        if (commitType === void 0) { commitType = BulkCommitType.StopOnFirstFailure; }
        var payload = {
            queueItems: queueItems.map(function (item) { return _this._toPoco(item); }),
            queueName: queueName,
            commitType: commitType,
        };
        return this._http.post(this._endpoint, JSON.stringify(payload)).pipe(map(function (response) { return _this._toDto(response, MapperService.bulkQueueItemResponseMap); }));
    };
    BulkAddItemsModalService.prototype._parseDate = function (row, errors, field, dateString) {
        if (!dateString) {
            return;
        }
        var parsedDate = moment.tz(dateString, SUPPORTED_DATE_FORMATS, true, this._appState.settings.get(Setting.timezone));
        if (parsedDate.isValid()) {
            return parsedDate;
        }
        errors.push({
            type: ICSVParseErrorType.FieldError,
            code: ICSVParseErrorCode.InvalidData,
            row: row,
            field: field,
        });
    };
    BulkAddItemsModalService.prototype._parseSpecificContent = function (row) {
        var specificContent = Object.keys(row)
            .filter(function (key) {
            return !KNOWN_FIELDS.includes(key) &&
                key !== '';
        })
            .reduce(function (obj, key) {
            obj[key] = row[key];
            return obj;
        }, {});
        if (isEmptyObject(specificContent)) {
            return void 0;
        }
        return specificContent;
    };
    BulkAddItemsModalService.prototype._parsePriority = function (index, errors, priority) {
        if (!priority) {
            return;
        }
        var isStringValue = isNaN(Number(priority));
        var safePriority;
        if (isStringValue) {
            safePriority = priority.toLowerCase().trim();
        }
        else {
            safePriority = Number(priority);
        }
        if (ItemPriority[safePriority] != null) {
            return QueueItemPriority[(isStringValue ?
                safePriority :
                ItemPriority[safePriority])];
        }
        errors.push({
            type: ICSVParseErrorType.FieldError,
            code: ICSVParseErrorCode.InvalidData,
            row: index,
            field: CSVFields.Priority,
        });
    };
    BulkAddItemsModalService.prototype._rowMapper = function (row, index, errors) {
        return {
            reference: row.Reference != null ? "" + row.Reference : row.Reference,
            specificContent: this._parseSpecificContent(row),
            dueDate: this._parseDate(index, errors, CSVFields.Deadline, row.Deadline),
            deferDate: this._parseDate(index, errors, CSVFields.Postpone, row.Postpone),
            priority: this._parsePriority(index, errors, row.Priority),
        };
    };
    BulkAddItemsModalService.prototype._reverseMapToCsv = function (row) {
        var returnedData = {};
        if (row.reference) {
            returnedData.Reference = row.reference;
        }
        if (row.dueDate) {
            returnedData.Deadline = row.dueDate.format(OUTPUT_DATE_FORMAT);
        }
        if (row.priority) {
            returnedData.Priority = row.priority;
        }
        if (row.specificContent) {
            Object.keys(row.specificContent).forEach(function (key) { return returnedData[key] = row.specificContent[key]; });
        }
        return returnedData;
    };
    BulkAddItemsModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BulkAddItemsModalService_Factory() { return new BulkAddItemsModalService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.CSVParser), i0.ɵɵinject(i3.FileDownloadService), i0.ɵɵinject(i4.AppStateFacade)); }, token: BulkAddItemsModalService, providedIn: "root" });
    return BulkAddItemsModalService;
}(ODataService));
export { BulkAddItemsModalService };
